import styled from 'styled-components';

export const ModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const datepickerWrapper = styled.div<{ $isRtl: boolean }>`
  background-color: #fff;
  border-radius: 16px;

  border: none !important;
  border-top: 1px solid #eee !important;
  text-align: center;

  background-color: hsl(220deg 90% 95%);
  * {
    font-family: ${({ $isRtl }) => ($isRtl ? 'Vazirmatn FD' : 'roboto')};
  }
  p {
    padding: 10px !important;
    cursor: pointer;
    font-family: inherit !important;
    :hover {
      color: hsl(220deg 90% 50%);
      font-weight: bold;
    }
  }
  .zm-Header {
    ~ * {
      direction: ${({ $isRtl }) => ($isRtl ? 'rtl' : 'ltr')};
    }
  }
`;
